import request from '../utils/http'

const qccapis = {
    //查询公司列表
    getCompanyList : query => {
        return request({
            url: '/qcc/getCompanyList',
            method: 'get',
            params:query
        });
    },
    getLL : query => {
        return request({
            url: '/qcc/getLL',
            method: 'get',
            params:query
        });
    },
    getLLDetail : query => {
        return request({
            url: '/qcc/getLLDetail',
            method: 'get',
            params:query
        });
    },
    getCPDetail : query => {
        return request({
            url: '/qcc/getCPDetail',
            method: 'get',
            params:query
        });
    },
    getCPCase : query => {
        return request({
            url: '/qcc/getCPCase',
            method: 'get',
            params:query
        });
    },
       getCPCaseByType : query => {
        return request({
            url: '/qcc/getCPCaseByType',
            method: 'get',
            params:query
        });
    },
    getCredit : query => {
        return request({
            url: '/qcc/getCredit',
            method: 'get',
            params:query
        });
    },
    getLLDetailByCompany : query => {
        return request({
            url: '/qcc/getLLDetailByCompany',
            method: 'get',
            params:query
        });
    },
    
}


export default qccapis
